// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b37bffc5","teamsContainer":"d3ed4c65","team":"c28edb63","leftCol":"e4d7627e","teamName":"da019ce4","id":"fd71da74"};